const _ = require('lodash');

const bundleTemplate = require('./bundle-template.html').trim();

const productTemplate = '<bws-product product="product" product-collection="productCollection"></bws-product>';


function createProductDetailCard() {
    return {
        template: '<wow-detail-product></wow-detail-product>',
        data: {}
    };
}

function createProductCard(product, productCollection) {

    return {
        template: productTemplate,
        data: { product, productCollection },
        detail: createProductDetailCard()
    };
}

function createProductCards(products, productCollection) {
    return _.map(products, function (product, i) {
        return createProductCard(product, productCollection[i]);
    });
}

function createBundleCard(bundle, flipped) {
    if (bundle.Products.length === 1) {
        return createProductCard(bundle.Products[0]);
    }

    return {
        template: bundleTemplate,
        data: {
            bundle,
            flipped: !!flipped
        },
        detail: createProductDetailCard()
    };
}

function createBundleCards(bundles, flipped) {
    return _.map(bundles, function (bundle) {
        return createBundleCard(bundle, flipped);
    });
}

module.exports = {
    createBundleCard,
    createBundleCards,
    createProductCard,
    createProductCards
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shelfproduct/shelfbundle-card-factory.js
 **/